export default "__VITE_ASSET__3LJDU7G9__"